module.exports = __webpack_public_path__ + "img/zhifubao.04d2e330.png";